<template>
  <a
    :href="`/${product.slug}`"
    :aria-label="product.name"
  >
    <article class="flex gap-x-4 items-start hover:text-gray-900 text-gray-500 transition-colors">
      <VVisibilityState
        v-slot="{ visioned }"
        class="w-16 h-16 md:w-24 md:h-24 grow-0 shrink-0 relative"
      >
        <template v-if="visioned">
          <VProgressiveImage
            :src="props.product.medias.find((media) => media.collection_name === 'default').original_url"
            :width="300"
            :height="200"
          />
        </template>
      </VVisibilityState>
      <div class="space-y-2">
        <p class="text-sm font-normal ">
          {{ product.name }}
        </p>
        <ProductPrice :product="product" />
      </div>
    </article>
  </a>
</template>
<script setup>
import ProductPrice from '../../productList/components/ProductPrice.vue';
import VVisibilityState from '../../../components/state/VVisibilityState.vue';
import VProgressiveImage from '../../../components/common/VProgressiveImage.vue';

const props = defineProps({
  product: {
    type: Object,
    required: true,
  },
});

</script>
